import { Dispatch } from "react";
import * as actionTypes from "../actionTypes/Index";
import {
  IActionType,
  IProductCategory,
  IGetQueryParams,
  IWarehousePayload,
  IOdooTaxResponse,
  IOdooTaxListResponse,
  IGlobalProductPayload,
  IDeliveryOption,
} from "../../interfaces/Index";
import {
  fetchProductTypeApiCall,
  fetchProductBrandApiCall,
  fetchProductUomApiCall,
  fetchGlobalProductsDetailsApiCall,
  fetchWareHouseNamesApiCall,
  fetchOdooTaxApiCall,
  createProductGlobalApiCall,
  updateGlobalProductApiCall,
  multiPartUploadApiCall,
  fetchDeliveryOptionsApiCall,
} from "../sources/GlobalProductSource";
import { uploadImageApiCall } from "utils/UploadImage";

export const createGlobalProductInit = () => ({
  type: actionTypes.CREATE_GLOBAL_PRODUCT_INIT,
});

export const createGlobalProductSuccess = () => ({
  type: actionTypes.CREATE_GLOBAL_PRODUCT_SUCCESS,
});

export const createGlobalProductFail = (error: string | object | null) => ({
  type: actionTypes.CREATE_GLOBAL_PRODUCT_FAIL,
  error,
});

export const getProductTypeInit = () => ({
  type: actionTypes.GET_PRODUCT_TYPE_INIT,
});

export const getProductTypeSuccess = (payload: Array<any>) => ({
  type: actionTypes.GET_PRODUCT_TYPE_SUCCESS,
  payload,
});

export const getProductTypeFail = (error: string | object | null) => ({
  type: actionTypes.GET_PRODUCT_TYPE_FAIL,
  error,
});

export const getProductUomInit = () => ({
  type: actionTypes.GET_PRODUCT_UOM_INIT,
});

export const getProductUomSuccess = (payload: Array<any>) => ({
  type: actionTypes.GET_PRODUCT_UOM_SUCCESS,
  payload,
});

export const getProductUomFail = (error: string | object | null) => ({
  type: actionTypes.GET_PRODUCT_UOM_FAIL,
  error,
});

export const fetchProductInit = () => ({
  type: actionTypes.GET_PRODUCTS_INIT,
});

export const fetchGlobalProductDetailsInit = () => ({
  type: actionTypes.GET_GLOBAL_PRODUCTS_DETAILS_INIT,
});

export const fetchGlobalProductDetailsSuccess = (
  payload: IGlobalProductPayload | null
) => ({
  type: actionTypes.GET_GLOBAL_PRODUCTS_DETAILS_SUCCESS,
  payload,
});

export const fetchGlobalProductDetailsFail = (
  error: string | object | null
) => ({
  type: actionTypes.GET_GLOBAL_PRODUCTS_DETAILS_FAIL,
  error,
});

export const clearProductDetails = () => ({
  type: actionTypes.CLEAR_GLOBAL_PRODUCT_DETAILS,
});

export const productBulkUploadInit = () => ({
  type: actionTypes.BULK_UPLOAD_INIT,
});

export const productBulkUploadSuccess = () => ({
  type: actionTypes.BULK_UPLOAD_SUCCESS,
});

export const productBulkUploadFail = (error: string | object | null) => ({
  type: actionTypes.BULK_UPLOAD_FAIL,
  error,
});

export const productInventoryUploadInit = () => ({
  type: actionTypes.INVENTORY_UPLOAD_INIT,
});

export const productInventoryUploadSuccess = () => ({
  type: actionTypes.INVENTORY_UPLOAD_SUCCESS,
});

export const productInventoryUploadFail = (error: string | object | null) => ({
  type: actionTypes.INVENTORY_UPLOAD_FAIL,
  error,
});

export const productGlobalUpdateInit = () => ({
  type: actionTypes.UPDATE_GLOBAL_PRODUCT_INIT,
});

export const productGlobalUpdateSuccess = () => ({
  type: actionTypes.UPDATE_GLOBAL_PRODUCT_SUCCESS,
});

export const productGlobalUpdateFail = (error: string | object | null) => ({
  type: actionTypes.UPDATE_GLOBAL_PRODUCT_FAIL,
  error,
});

export const getProductBrandInit = () => ({
  type: actionTypes.GET_PRODUCT_BRANDS_INIT,
});

export const getProductBrandSuccess = (payload: Array<any>) => ({
  type: actionTypes.GET_PRODUCT_BRANDS_SUCCESS,
  payload,
});

export const getProductBrandFail = (error: string | object | null) => ({
  type: actionTypes.GET_PRODUCT_BRANDS_FAIL,
  error,
});

export const getWareHouseNamesInit = () => ({
  type: actionTypes.GET_WAREHOUSE_INIT,
});

export const getWareHouseNamesSuccess = (
  payload: Array<IWarehousePayload>
) => ({
  type: actionTypes.GET_WAREHOUSE_SUCCESS,
  payload,
});

export const getWareHouseNamesFail = (error: string | object | null) => ({
  type: actionTypes.GET_WAREHOUSE_FAIL,
  error,
});

export const getDeliveryOptionsInit = () => ({
  type: actionTypes.GET_DELIVERY_OPTIONS_INIT,
});

export const getDeliveryOptionsSuccess = (payload: Array<IDeliveryOption>) => ({
  type: actionTypes.GET_DELIVERY_OPTIONS_SUCCESS,
  payload,
});

export const getDeliveryOptionsFail = (error: string | object | null) => ({
  type: actionTypes.GET_DELIVERY_OPTIONS_FAIL,
  error,
});

export const getOdooTaxInit = () => ({
  type: actionTypes.GET_ODOO_TAX_INIT,
});

export const getOdooTaxSuccess = (
  payload: IOdooTaxListResponse[] | IOdooTaxResponse
) => ({
  type: actionTypes.GET_ODOO_TAX_SUCCESS,
  payload,
});

export const getOdooTaxFail = (error: string | object | null) => ({
  type: actionTypes.GET_ODOO_TAX_FAIL,
  error,
});

export const createGlobalProduct =
  (payload: FormData) => (dispatch: Dispatch<IActionType>) => {
    dispatch(createGlobalProductInit());
    return createProductGlobalApiCall(payload)
      .then(() => dispatch(createGlobalProductSuccess()))
      .catch((e: object | null | string) =>
        dispatch(createGlobalProductFail(e))
      );
  };

export const fetchProductTypes = () => (dispatch: Dispatch<IActionType>) => {
  dispatch(getProductTypeInit());
  return fetchProductTypeApiCall()
    .then((productTypes: Array<IProductCategory>) =>
      dispatch(getProductTypeSuccess(productTypes))
    )
    .catch((e: object | null | string) => dispatch(getProductTypeFail(e)));
};

export const fetchProductUom = () => (dispatch: Dispatch<IActionType>) => {
  dispatch(getProductUomInit());
  return fetchProductUomApiCall()
    .then((productTypes: Array<IProductCategory>) =>
      dispatch(getProductUomSuccess(productTypes))
    )
    .catch((e: object | null | string) => dispatch(getProductUomFail(e)));
};
export const bulkUploadProduct =
  (payload: FormData, url: string) => (dispatch: Dispatch<IActionType>) => {
    dispatch(productBulkUploadInit());
    return multiPartUploadApiCall(payload, url)
      .then(() => dispatch(productBulkUploadSuccess()))
      .catch((e: object | null | string) => dispatch(productBulkUploadFail(e)));
  };

export const inventoryUploadProduct =
  (payload: FormData, url: string) => (dispatch: Dispatch<IActionType>) => {
    dispatch(productInventoryUploadInit());
    return multiPartUploadApiCall(payload, url)
      .then(() => dispatch(productInventoryUploadSuccess()))
      .catch((e: object | null | string) =>
        dispatch(productInventoryUploadFail(e))
      );
  };

export const getGlobalProductDetails =
  (id: string) => (dispatch: Dispatch<IActionType>) => {
    dispatch(fetchGlobalProductDetailsInit());
    return fetchGlobalProductsDetailsApiCall(id)
      .then((details: IGlobalProductPayload) => {
        dispatch(fetchGlobalProductDetailsSuccess(details));
      })
      .catch((e: object | null | string) => {
        dispatch(fetchGlobalProductDetailsFail(e));
      });
  };

export const updateGlobalProduct =
  (id: string, payload: FormData) => (dispatch: Dispatch<IActionType>) => {
    dispatch(productGlobalUpdateInit());
    return updateGlobalProductApiCall(id, payload)
      .then(() => dispatch(productGlobalUpdateSuccess()))
      .catch((e: object | null | string) =>
        dispatch(productGlobalUpdateFail(e))
      );
  };

export const clearProductDetailsAction =
  () => (dispatch: Dispatch<IActionType>) => {
    return dispatch(clearProductDetails());
  };

export const uploadImageAndCreateUpdateGlobalProductAction =
  (fieldPayload: FormData, jsonData: any, id: string) =>
  (dispatch: Dispatch<IActionType>) => {
    dispatch(id ? productGlobalUpdateInit() : createGlobalProductInit());
    return uploadImageApiCall("product", fieldPayload)
      .then((data: any) => {
        return data;
      })
      .then((data: any) => {
        jsonData.imageId = data.id || "";
        jsonData.imageSrc = data.path || "";
        fieldPayload.append(
          "properties",
          new Blob([JSON.stringify(jsonData)], {
            type: "application/json",
          })
        );
        if (id) {
          return updateGlobalProductApiCall(id, fieldPayload)
            .then(() => dispatch(productGlobalUpdateSuccess()))
            .catch((e: object | null | string) =>
              dispatch(productGlobalUpdateFail(e))
            );
        }
        return createProductGlobalApiCall(fieldPayload)
          .then(() => dispatch(createGlobalProductSuccess()))
          .catch((e: object | null | string) =>
            dispatch(createGlobalProductFail(e))
          );
      })
      .catch((e: object | null | string) =>
        dispatch(id ? productGlobalUpdateFail(e) : createGlobalProductFail(e))
      );
  };

export const fetchProductBrands =
  (queryParams?: IGetQueryParams) => (dispatch: Dispatch<IActionType>) => {
    dispatch(getProductBrandInit());
    return fetchProductBrandApiCall(queryParams)
      .then((productBrands: Array<IProductCategory>) =>
        dispatch(getProductBrandSuccess(productBrands))
      )
      .catch((e: object | null | string) => dispatch(getProductBrandFail(e)));
  };

export const fetchWareHouseNames = () => (dispatch: Dispatch<IActionType>) => {
  dispatch(getWareHouseNamesInit());
  return fetchWareHouseNamesApiCall()
    .then((wareHouseNames: Array<IWarehousePayload>) =>
      dispatch(getWareHouseNamesSuccess(wareHouseNames))
    )
    .catch((e: object | null | string) => dispatch(getWareHouseNamesFail(e)));
};

export const fetchDeliveryOptions = () => (dispatch: Dispatch<IActionType>) => {
  dispatch(getDeliveryOptionsInit());
  return fetchDeliveryOptionsApiCall()
    .then((deliveryOptions: Array<IDeliveryOption>) =>
      dispatch(getDeliveryOptionsSuccess(deliveryOptions))
    )
    .catch((e: object | null | string) => dispatch(getDeliveryOptionsFail(e)));
};

export const fetchTaxFromOdoo =
  (id: string = "") =>
  (dispatch: Dispatch<IActionType>) => {
    dispatch(getOdooTaxInit());
    return fetchOdooTaxApiCall(id)
      .then((tax: IOdooTaxListResponse[] | IOdooTaxResponse) =>
        dispatch(getOdooTaxSuccess(tax))
      )
      .catch((e: object | null | string) => dispatch(getOdooTaxFail(e)));
  };
